import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class EmpresaService extends BaseService {
  constructor() {
    super(ConfigApi.empresaURL);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.razaoSocial = '';
    this.limit = 0;
    this.page = 0;
  }
}
export default new EmpresaService();
